import Vue from 'vue'
import Router from 'vue-router'

import Landing from './views/Landing.vue'
import InfoIntroduction from './views/InfoIntroduction.vue'
import Registration from './views/Registration.vue'
import Organization from './views/Organization.vue'
import InfoCircles from './views/InfoCircles.vue'
import Coworkers from './views/Coworkers.vue'
import InfoResults from './views/InfoResults.vue'
import Colleagues from './views/Colleagues.vue'
import Trends from './views/Trends.vue'
import Details from './views/Details.vue'
import Results from './views/Results.vue'
import InfoCoaching from './views/InfoCoaching.vue'
import CoachingConfirmation from './views/CoachingConfirmation.vue'
import Feedback from './views/Feedback.vue'
import Finished from './views/Finished.vue'
import TrendsSelector from './views/TrendsSelector.vue'
import InsufficientTrendsSelector from './views/InsufficientTrendsSelector.vue'

import progress from './progress.json'

import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    document.querySelector('.c-main').scrollTop = 0
  },
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing,
      meta: {
        visualIndented: true
      }
    },
    {
      path: '/infointroduction',
      name: 'infointroduction',
      component: InfoIntroduction,
      meta: {
        visualIndented: true
      }
    },
    {
      path: '/registration',
      name: 'registration',
      component: Registration
    },
    {
      path: '/organization',
      name: 'organization',
      component: Organization
    },
    {
      path: '/infocircles',
      name: 'infocircles',
      component: InfoCircles
    },
    {
      path: '/coworkers',
      name: 'coworkers',
      component: Coworkers
    },
    {
      path: '/inforesults',
      name: 'inforesults',
      component: InfoResults
    },
    {
      path: '/colleagues',
      name: 'colleagues',
      component: Colleagues
    },
    {
      path: '/trendsselector',
      name: 'trendsselector',
      component: TrendsSelector
    },
    {
      path: '/insufficienttrendsselector',
      name: 'insufficienttrendsselector',
      component: InsufficientTrendsSelector
    },
    {
      path: '/trends',
      name: 'trends',
      component: Trends
    },
    {
      path: '/trend/:id',
      name: 'trend',
      component: Details
    },
    {
      path: '/results',
      name: 'results',
      component: Results
    },
    {
      path: '/infocoaching',
      name: 'infocoaching',
      component: InfoCoaching
    },
    {
      path: '/coachingconfirmation',
      name: 'coachingconfirmation',
      component: CoachingConfirmation
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Feedback
    },
    {
      path: '/finished',
      name: 'finished',
      component: Finished
    }
  ]
})

// Indicate on what progress level each page starts
const progressMarkers = {
  STARTED: 'landing',
  REGISTRATION_COMPLETED: 'organization',
  ORGANIZATION_COMPLETED: 'infocircles',
  COWORKERS_COMPLETED: 'inforesults',
  COLLEAGUES_INVITED: 'trendsselector',
  TRENDS_SELECTED: 'trends',
  TRENDS_STARTED: 'trends',
  TRENDS_COMPLETED: 'results',
  FEEDBACK_SENT: 'finished'
}

const pageProgress = {
  landing: progress.STARTED,
  infointroduction: progress.STARTED,
  registration: progress.STARTED,
  organization: progress.REGISTRATION_COMPLETED,
  infocircles: progress.ORGANIZATION_COMPLETED,
  coworkers: progress.ORGANIZATION_COMPLETED,
  inforesults: progress.COWORKERS_COMPLETED,
  colleagues: progress.COWORKERS_COMPLETED,
  trendsselector: progress.COLLEAGUES_INVITED,
  trends: progress.TRENDS_SELECTED,
  trend: progress.TRENDS_STARTED,
  results: progress.TRENDS_COMPLETED,
  infocoaching: progress.TRENDS_COMPLETED,
  coachingconfirmation: progress.TRENDS_COMPLETED,
  feedback: progress.TRENDS_COMPLETED,
  finished: progress.FEEDBACK_SENT
}

router.beforeEach((to, from, next) => {
	//retrieve the meta data of each page (i.e. setVisualIndent)
	//and initialize the global variable setVisualIndent of the store
	//so that the view can be rendered correctly
  if (to.matched.some(record => record.meta.visualIndented)) {
    store.commit('setVisualIndent', false)
    next()
  } else {
    store.commit('setVisualIndent', true)
    next()
  }

	//make sure you cannot go back to previous pages/states in the app
  if (pageProgress[to.name] < progress[store.state.progress]) {
    if (progressMarkers.hasOwnProperty(store.state.progress)) {
      //stay on the page where you are right now, you cannot go back
			next({ name: progressMarkers[store.state.progress] })
    } else {
      next()
    }
  }
})

//initialize the default router with our own router
//kind of return value
export default router
